import { useQueryClient } from '@tanstack/react-query';
import { threadsItemCount } from 'constants/pageSizes';
import { useNotification } from 'hooks/notification/useNotification';
import { useSignalR } from 'hooks/useSiglanR';
import { useSignalREvent } from 'hooks/useSignalREvent';
import { useStoreState } from 'providers/StoreStateContext';
import { useEffect, useMemo, useRef } from 'react';
import { ISeetingIndividualResponse } from 'services/settings/individual/types';
import { IChatEvents } from './types';

//return useQuery<ISeetingIndividualResponse, DefaultError>({
// queryKey: ['licenceConfiguration'],

export const useChatConnection = () => {
  const { token } = useStoreState();

  const notification = useNotification();

  const queryClient = useQueryClient();

  const licenceConfiguration =
    queryClient.getQueryData<ISeetingIndividualResponse>([
      'licenceConfiguration',
    ]);

  const connectionRef = useRef({
    token,
    licenceConfiguration,
  });

  useEffect(() => {
    connectionRef.current.token = token;
    connectionRef.current.licenceConfiguration = licenceConfiguration;
  }, [token, licenceConfiguration]);

  const isDisabled = useMemo(
    () => !connectionRef.current.licenceConfiguration?.clientModuleAccess,
    [connectionRef.current.licenceConfiguration?.clientModuleAccess],
  );

  const { connection } = useSignalR('messages', {
    disabled: isDisabled,
  });

  const invalidateThreadLists = async (labelId: string) => {
    await queryClient.invalidateQueries({
      queryKey: ['chats-list', { itemCount: threadsItemCount }],
    });
    await queryClient.invalidateQueries({
      queryKey: ['chats-list', { labelId, itemCount: threadsItemCount }],
    });
  };

  useSignalREvent<IChatEvents, 'SendMessage'>(
    connection,
    'SendMessage',
    async message => {
      await queryClient.invalidateQueries({
        queryKey: [
          'messages-list',
          { messageThreadId: message.messageThreadId },
        ],
      });
      await invalidateThreadLists(message.senderId);

      await queryClient.refetchQueries({
        queryKey: ['chat-unread-count'],
      });

      notification.message(message);
    },
  );

  useSignalREvent<IChatEvents, 'ReadMessage'>(
    connection,
    'ReadMessage',
    async message => {
      console.log(message);
      await queryClient.invalidateQueries({
        queryKey: [
          'messages-list',
          { messageThreadId: message.messageThreadId },
        ],
      });

      await invalidateThreadLists(message.senderId);

      await queryClient.refetchQueries({
        queryKey: ['chat-unread-count'],
      });
    },
  );

  useSignalREvent<IChatEvents, 'CloseThread'>(
    connection,
    'CloseThread',
    async message => {
      await invalidateThreadLists(message.senderId);
      await queryClient.invalidateQueries({
        queryKey: [
          'messages-list',
          { messageThreadId: message.messageThreadId },
        ],
      });

      await queryClient.refetchQueries({
        queryKey: ['chat-unread-count'],
      });
    },
  );

  if (isDisabled) return null;

  return connection;
};

//  queryKey: ['messages-list', params]
//  queryKey: ['chats-list', params],
//  queryKey: ['chat', id],

//  chat.senderId to LabelId potrzebne dla chats-list
//  chat.messageThreadId to threadId potrzebne dla messages-list i chat
